// extracted by mini-css-extract-plugin
export default {"home":"Home_home__1zFju","info":"Home_info__cE+t2","download-btn":"Home_download-btn__P3hGO","hello-btn":"Home_hello-btn__u88zL","img-container":"Home_img-container__GvRRX"};